import type { Table } from 'schema-dts';
import ChartDataTable from '@/pages/CompanyReport/components/Overview/components/ChartDataTable';
import DocumentSchema from '@/components/DocumentSchema';

interface Props {
  tickerSymbol: string;
  industry: string;
  country: string;
  companyVolatility: string;
  industryVolatility: string;
  marketVolatility: string;
  marketVolatilityP10: string;
  marketVolatilityP90: string;
}

const PriceVolatilityTable = ({
  tickerSymbol,
  industry,
  country,
  companyVolatility,
  industryVolatility,
  marketVolatility,
  marketVolatilityP10,
  marketVolatilityP90,
}: Props) => {
  const header = `${tickerSymbol} volatility`;
  const caption = `Is ${tickerSymbol}'s price volatile compared to industry and market?`;

  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: header,
          about: caption,
        }}
      />
      <ChartDataTable
        data-cy-id="overview-price-volatility-table"
        columnTextAlignments="l"
      >
        <caption>{caption}</caption>
        <thead>
          <tr>
            <th colSpan={2}>{header}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{`${tickerSymbol} Average Weekly Movement`}</td>
            <td>{companyVolatility}</td>
          </tr>
          <tr>
            <td>{`${industry} Industry Average Movement`}</td>
            <td>{industryVolatility}</td>
          </tr>
          <tr>
            <td>Market Average Movement</td>
            <td>{marketVolatility}</td>
          </tr>
          <tr>
            <td>{`10% most volatile stocks in ${country} Market`}</td>
            <td>{marketVolatilityP90}</td>
          </tr>
          <tr>
            <td>{`10% least volatile stocks in ${country} Market`}</td>
            <td>{marketVolatilityP10}</td>
          </tr>
        </tbody>
      </ChartDataTable>
    </>
  );
};

export default PriceVolatilityTable;
